import { Box, Flex, Heading } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { CheckIcon, ErrorOutlineIcon, WarningIcon } from 'shared/icons';
import { ApplyStatus } from '../ApplyJob.store';

import './job-apply-status.scss';

function JobApplyStatusView({ status }: { status: ApplyStatus }) {
   const { t } = useTranslation('global');

   return (
      <div
         className={`jobApplyResultBox ${status === 'success' ? 'success' : status === 'error' ? 'error' : 'warning'}`}
      >
         {
            {
               success: (
                  <Flex direction="column" align="center" justify="center">
                     <Box mr="1">
                        <CheckIcon color="#138063" width={40} height={40} />
                     </Box>

                     <Heading as="h2" weight="medium" mt="6">
                        {t('jobDescription.jobAppliedSuccess')}
                     </Heading>
                  </Flex>
               ),
               error: (
                  <Flex direction="column" align="center" justify="center">
                     <Box mr="1">
                        <ErrorOutlineIcon color="#294A9C" width={40} height={40} />
                     </Box>

                     <Heading as="h2" weight="medium">
                        {t('jobDescription.applyError')}
                     </Heading>
                  </Flex>
               ),
               warning: (
                  <Flex direction="column" align="center" justify="center">
                     <Box mr="1">
                        <WarningIcon width={40} height={40} color="#FFAD42" />
                     </Box>

                     <Heading as="h2" weight="medium">
                        {t('jobDescription.jobAlreadyApplied')}
                     </Heading>
                  </Flex>
               ),
               pending: <></>,
            }[status]
         }
      </div>
   );
}

export const JobApplyStatus = observer(JobApplyStatusView);
